
import { defineComponent, ref, computed, watch, onMounted } from "vue";
import { trans, transChoice } from "@/globals/translator";
import useSearch from "@/composables/useSearch";
import { useRoute, useRouter } from "vue-router";
//import { debouncedWatch } from "@vueuse/core";
import PosterCard from "@/components/media/PosterCard.vue";
import ArticleCard from "@/components/article/ArticleCard.vue";
import SearchInput from "@/components/common/SearchInput.vue";
import Grid from "@moonlight/vue3/components/Grid.vue";
import Row from "@moonlight/vue3/components/Row.vue";
import Col from "@moonlight/vue3/components/Col.vue";
import { useHead } from "@vueuse/head";

export default defineComponent({
  components: {
    SearchInput,
    PosterCard,
    ArticleCard,
    Grid,
    Row,
    Col,
  },
  setup() {
    const router = useRouter();
    const route = useRoute();
    const { searchResults, fetchSearchResults } = useSearch();

    const searchQuery = ref<string>(route.query.q?.toString() || "");

    const searchResultsCount = computed<number>(
      () =>
        searchResults.value.medias.length + searchResults.value.articles.length
    );

    // Change query every time we have new search results
    watch(searchResults, () =>
      router.replace({ query: { ...route.query, q: searchQuery.value } })
    );

    if (searchQuery.value) {
      fetchSearchResults(searchQuery.value);
    }

    // debouncedWatch(searchQuery, () => fetchSearchResults(searchQuery.value), {
    //   debounce: 200,
    // });

    const searchInput = ref<InstanceType<typeof SearchInput>>();

    onMounted(() => {
      if (!route.query.q?.toString()) {
        searchInput.value?.focus();
      }
    });

    useHead({
      title: computed(() => {
        return trans("general.search_results_for_term", {
          term: searchQuery.value,
        }) as string;
      }),
    });

    function handleKeyEnter() {
      if (!searchQuery.value.length) {
        return;
      }
      if (searchQuery.value !== route.query.q) {
        fetchSearchResults(searchQuery.value);
      }
    }

    return {
      searchInput,
      trans,
      transChoice,
      searchQuery,
      searchResults,
      searchResultsCount,
      fetchSearchResults,
      handleKeyEnter,
    };
  },
});
